export default __webpack_public_path__ + "static/media/GothamPro-Black.84f14561.woff";